// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataset-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 4px 0;
}

.dataset-pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.dataset-pagination-btn {
  min-width: 40px;
  min-height: 38px;
  padding: 0 12px;
  font-size: 13px;
}

.dataset-pagination-btn.nav {
  min-width: 84px;
}

.dataset-pagination-ellipsis {
  width: 28px;
  text-align: center;
  color: #9ca3af;
  font-weight: 600;
}

.dataset-pagination-summary {
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".dataset-pagination {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 4px 0;\n}\n\n.dataset-pagination-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dataset-pagination-btn {\n  min-width: 40px;\n  min-height: 38px;\n  padding: 0 12px;\n  font-size: 13px;\n}\n\n.dataset-pagination-btn.nav {\n  min-width: 84px;\n}\n\n.dataset-pagination-ellipsis {\n  width: 28px;\n  text-align: center;\n  color: #9ca3af;\n  font-weight: 600;\n}\n\n.dataset-pagination-summary {\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
